'use client'

import { SessionProvider } from 'next-auth/react'
import { PropsWithChildren } from 'react'

import { AuthProvider } from '@/components/providers/AuthProvider'

export const SessionAuthProvider: React.FC<PropsWithChildren> = ({ children }) => (
  <SessionProvider refetchOnWindowFocus={true}>
    <AuthProvider>{children}</AuthProvider>
  </SessionProvider>
)
